// Directly set the API URL to ensure it's always available
const API_URL = process.env.NODE_ENV === 'production' 
  ? 'https://chatbot-backend-v-4.onrender.com'
  : 'http://localhost:5000';

export const API_ENDPOINTS = {
  LOGIN: `${API_URL}/api/users/login`,
  SIGNUP: `${API_URL}/api/users/signup`,
  SEND_OTP: `${API_URL}/api/users/send-otp`,
  VERIFY_OTP: `${API_URL}/api/users/verify-otp`,
  RESEND_OTP: `${API_URL}/api/users/resend-otp`,
  CHECK_USERNAME: `${API_URL}/api/users/check-username`,
  FORGOT_PASSWORD: `${API_URL}/api/users/forgot-password`,
  RESET_PASSWORD: `${API_URL}/api/users/reset-password`,
  RESEND_PASSWORD_RESET_OTP: `${API_URL}/api/users/resend-password-reset-otp`,
  CHAT: `${API_URL}/api/chat/send`,
  BOOKS: `${API_URL}/api/books`,
  CHAPTERS: `${API_URL}/api/chapters`,
  SUBSCRIPTIONS: `${API_URL}/api/subscriptions`,
  REFRESH_MEDIA_URL: `${API_URL}/api/media/refresh-url`,
  ADMIN_LOGIN: `${API_URL}/api/admins/login`,
  ADMIN_REGISTER: `${API_URL}/api/admins/register`,
  GET_BOOKS: `${API_URL}/api/books`,
  GET_ADMIN_BOOKS: `${API_URL}/api/books/admin/all`,
  ADD_BOOK: `${API_URL}/api/books`,
  ADD_CHAPTER: `${API_URL}/api/chapters`,
  DELETE_BOOK: `${API_URL}/api/books/:bookId`,
  DELETE_CHAPTER: `${API_URL}/api/chapters/:chapterId`,
  SET_CHAPTER_LEARN: `${API_URL}/api/chapters/:chapterId/learn`,
  GET_PUBLISHERS: `${API_URL}/api/app/publishers`,
  USER_SIGNUP: `${API_URL}/api/users/register`,
  GET_USER: `${API_URL}/api/users/me`,
  UPDATE_USER_PROFILE: `${API_URL}/api/users/profile`,
  UPLOAD_PROFILE_PICTURE: `${API_URL}/api/users/upload-profile-picture`,
  DELETE_PROFILE_PICTURE: `${API_URL}/api/users/delete-profile-picture`,
  CHANGE_PASSWORD: `${API_URL}/api/users/change-password`,
  GET_BOOK_CHAPTERS: `${API_URL}/api/books/:bookId/chapters`,
  GET_ADMIN_BOOK_CHAPTERS: `${API_URL}/api/books/admin/:bookId/chapters`,
  GET_SUBSCRIPTIONS: `${API_URL}/api/subscriptions/my-subscriptions`,
  UNSUBSCRIBE_BOOK: `${API_URL}/api/subscriptions/:bookId`,
  GET_CHAPTER_HISTORY: `${API_URL}/api/chat/chapter-history/:chapterId`,
  GET_CHAT_HISTORY: `${API_URL}/api/chat/history/:userId`,
  SEND_AUDIO: `${API_URL}/api/chat/send-audio`,
  TRANSCRIBE_AUDIO: `${API_URL}/api/chat/transcribe`,
  UPLOAD_BOOK_COVER: `${API_URL}/api/books/upload-cover`,
  GET_AUDIO: `${API_URL}/api/chat/audio/:fileId`,
  
  // Add the new chapter stats endpoint
  GET_CHAPTER_STATS: `${API_URL}/api/chat/chapter-stats/:chapterId`,
  
  // Chapter preparation endpoints
  PROCESS_TEXT_BATCH: `${API_URL}/api/chapters/process-text-batch`,
  PROCESS_TEXT_BATCH_V2: `${API_URL}/api/chapters/process-text-batch-v2`,
  PROCESS_TEXT_BATCH_V2_STREAM: `${API_URL}/api/chapters/process-text-batch-v2-stream`,
  ENHANCED_BATCH_PROCESS: `${API_URL}/api/chapters/enhanced-batch-process`,
  
  // Score and statistics endpoints
  GET_RECENT_ACTIVITY: `${API_URL}/api/scores/recent-activity/:userId`,
  GET_SCOREBOARD: `${API_URL}/api/scores/scoreboard/:userId`,
  GET_PROGRESS_DETAILS: `${API_URL}/api/scores/progress-details/:userId`,
  GET_ASSESSMENT_DATA: `${API_URL}/api/scores/assessment-data/:userId`,
  GET_PERFORMANCE_OVERVIEW: `${API_URL}/api/scores/performance-overview/:userId`,
  
  // Unified scores endpoint (NEW - replaces all above)
  GET_UNIFIED_SCORES: `${API_URL}/api/unified-scores/:userId`,
  
  // New Search and Collection APIs
  SEARCH_BOOKS: `${API_URL}/api/books/search`,
  SEARCH_SUGGESTIONS: `${API_URL}/api/books/search-suggestions`,
  SEARCH_WITH_STATUS: `${API_URL}/api/books/search-with-status`,
  GET_USER_COLLECTION: `${API_URL}/api/subscriptions/collection`,
  GET_COLLECTION_SUMMARY: `${API_URL}/api/subscriptions/collection/summary`,
  
  // User stats endpoints
  GET_USER_STATS: `${API_URL}/api/stats/user/:userId`,
  GET_USER_STATS_NEW: `${API_URL}/api/stats-new/user/:userId`,
  
  // Notification endpoints
  GET_NOTIFICATIONS: `${API_URL}/api/notifications`,
  
  // Admin endpoints
  ADMIN_DASHBOARD: `${API_URL}/api/admin/dashboard`,
  ADMIN_USERS: `${API_URL}/api/admin/users`,
  ADMIN_BOOKS: `${API_URL}/api/admin/books`,
  ADMIN_CHAPTERS: `${API_URL}/api/admin/chapters`,
  GENERATE_BOOK_COUPONS: `${API_URL}/api/books/:bookId/coupons/generate`,
  
  // Prompt management
  GET_PROMPTS: `${API_URL}/api/prompts`,
  UPDATE_PROMPT: `${API_URL}/api/prompts/:type`,
  
  // Config endpoints
  GET_CONFIG: `${API_URL}/api/config`,
  UPDATE_CONFIG: `${API_URL}/api/config/:key`,
  
  // Reset endpoints
  RESET_QUESTIONS: `${API_URL}/api/chat/reset-questions/:chapterId`,
  GET_PROGRESSION_STATUS: `${API_URL}/api/chat/progression-status/:chapterId`,
  
  // Test endpoints
  TEST_UPLOAD: `${API_URL}/api/books/test-upload`,
  FIX_ZERO_SCORES: `${API_URL}/api/chat/fix-zero-scores/:chapterId`,

  // Google-verified auth endpoints
  ACCOUNTS_BY_GOOGLE_TOKEN: `${API_URL}/api/users/accounts-by-google-token`,
  REGISTER_GOOGLE_VERIFIED: `${API_URL}/api/users/register-google-verified`,

  // Admin analytics dashboard
  ANALYTICS_OVERVIEW: `${API_URL}/api/analytics/overview`,
  ANALYTICS_TIMESERIES: `${API_URL}/api/analytics/timeseries`,
  ANALYTICS_USERS: `${API_URL}/api/analytics/users`,
  ANALYTICS_ERRORS: `${API_URL}/api/analytics/errors`,
  ANALYTICS_BOOKS: `${API_URL}/api/analytics/books`,
  // Both take an id: `${ANALYTICS_BOOK_CHAPTERS(bookId)}`.
  ANALYTICS_BOOK_CHAPTERS: (bookId) => `${API_URL}/api/analytics/books/${bookId}/chapters`,
  ANALYTICS_CHAPTER_TOP_USERS: (chapterId) => `${API_URL}/api/analytics/chapters/${chapterId}/top-users`,

  // Admin audiobooks (see chatbot-backend/docs/AUDIOBOOK_API.md, "Admin routes")
  ADMIN_AUDIOBOOKS: `${API_URL}/api/admin/audiobooks`,
  ADMIN_AUDIOBOOK: (bookId) => `${API_URL}/api/admin/audiobooks/${bookId}`,
  ADMIN_AUDIOBOOK_COVER_UPLOAD_URL: (bookId) => `${API_URL}/api/admin/audiobooks/${bookId}/cover-upload-url`,
  ADMIN_AUDIOBOOK_COVER_COMPLETE: (bookId) => `${API_URL}/api/admin/audiobooks/${bookId}/cover-complete`,
  ADMIN_AUDIOBOOK_CHAPTERS: (bookId) => `${API_URL}/api/admin/audiobooks/${bookId}/chapters`,
  ADMIN_AUDIOBOOK_CHAPTER_ORDER: (bookId) => `${API_URL}/api/admin/audiobooks/${bookId}/chapter-order`,
  ADMIN_AUDIOBOOK_PUBLISH: (bookId) => `${API_URL}/api/admin/audiobooks/${bookId}/publish`,
  ADMIN_AUDIOBOOK_UNPUBLISH: (bookId) => `${API_URL}/api/admin/audiobooks/${bookId}/unpublish`,
  ADMIN_AUDIOBOOK_REPORT: (bookId) => `${API_URL}/api/admin/audiobooks/${bookId}/report`,
  // GET { total, used, unused }; add ?format=csv for every code. Generate with GENERATE_BOOK_COUPONS.
  ADMIN_AUDIOBOOK_COUPONS: (bookId) => `${API_URL}/api/admin/audiobooks/${bookId}/coupons`,
  ADMIN_AUDIOBOOK_CHAPTER: (chapterId) => `${API_URL}/api/admin/audiobook-chapters/${chapterId}`,
  ADMIN_AUDIOBOOK_CHAPTER_UPLOAD_URL: (chapterId) => `${API_URL}/api/admin/audiobook-chapters/${chapterId}/upload-url`,
  ADMIN_AUDIOBOOK_CHAPTER_UPLOAD_COMPLETE: (chapterId) => `${API_URL}/api/admin/audiobook-chapters/${chapterId}/upload-complete`,
  ADMIN_AUDIOBOOK_CHAPTER_PREVIEW_URL: (chapterId) => `${API_URL}/api/admin/audiobook-chapters/${chapterId}/preview-url`
};

// Export the base URL as well for direct usage
export { API_URL }; 